import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Button,
	Paper,
	TableSortLabel,
	Checkbox,
	FormControlLabel,
} from "@material-ui/core";
import { useFormik } from "formik";

import { useStore } from "@store/store";
import Pagination from "@components/pagination";
import Loader from "@components/loader";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";
import { schema } from "@utils/schemas";
import validationSchema from "@utils/validationSchemas";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import {
	dashboardRequestStatusColors,
	jobListingRequestStyle,
	getPermissions,
	utcToTimezone,
	isRolePermission,
  formatNetCharge
} from "@utils/commonFunctions";

import {
  dashboardListingHeader,
  dashboardInterstateListingHeader,
  routes,
  sourceId,
  jobStatus,
  swapType,
  handoffType
} from "@utils/constant";

import {
	ASSIGN_DRIVER,
	ASSIGN_DRIVER_SUCCESS,
	ASSIGN_DRIVER_FAILURE,
	RE_ASSIGN_DRIVER,
	RE_ASSIGN_DRIVER_SUCCESS,
	RE_ASSIGN_DRIVER_FAILURE,
	RE_ASSIGN_CHANGE_DRIVER,
	RE_ASSIGN_CHANGE_DRIVER_SUCCESS,
	RE_ASSIGN_CHANGE_DRIVER_FAILURE,
	CHANGE_DRIVER,
	CHANGE_DRIVER_SUCCESS,
	CHANGE_DRIVER_FAILURE,
  FETCH_LOCAL_DRIVERS,
  FETCH_LOCAL_DRIVERS_SUCCESS,
  FETCH_LOCAL_DRIVERS_FAILURE,
  FETCH_INTERSTATE_DRIVERS,
  FETCH_INTERSTATE_DRIVERS_SUCCESS,
  FETCH_INTERSTATE_DRIVERS_FAILURE,
  FETCH_INTERSTATE_JOBS_REASSIGN,
  FETCH_INTERSTATE_JOBS_REASSIGN_SUCCESS,
  FETCH_INTERSTATE_JOBS_REASSIGN_FAILURE,
  CREATE_HANDOFF,
  CREATE_HANDOFF_SUCCESS,
  CREATE_HANDOFF_FAILURE,
  CHECK_RELATED_PRIME_JOB,
  CHECK_RELATED_PRIME_JOB_SUCCESS,
  CHECK_RELATED_PRIME_JOB_FAILURE,
  RE_ASSIGN_CONSOLIDATED_JOB,
  RE_ASSIGN_CONSOLIDATED_JOB_SUCCESS,
  RE_ASSIGN_CONSOLIDATED_JOB_FAILURE
} from "@utils/actionTypes";
import API from "@services/axios";
import AssignDriverPopup from "../assignDriverPopup";
import ReassignDriverHandoffPopup from "../reassign-driver-handoff-popup";
import CustomConfirmationPopup from "@components/customConfirmationPopup";
import { TableStyle } from "./style";

function TableListing(props) {
	const classes = TableStyle();
	const [state, dispatch] = useStore();
	const [openDriverPopup, setOpenDriverPopup] = useState(false);
	const [openReassignDriverHandoffPopup, setOpenReassignDriverHandoffPopup] = useState(false);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
	const [jobId, setJobId] = useState("");
	const [error, setError] = useState("");
	const [type, setType] = useState("");
	const [status, setStatus] = useState("");
	const [truckId, setTruckId] = useState("");
	const [cityId, setCityId] = useState("");
  const [currentDriverId, setCurrentDriverId] = useState("");
  const [currentJob, setCurrentJob] = useState(null);
  const [sort, setSort] = useState({
    order: "",
    orderBy: ""
  });
	const isPermission =
		getPermissions() && isRolePermission(getPermissions(), "jobReview");

	const getDriver = () => {
    if (!props.isInterstate) { // For Local
      dispatch({ type: FETCH_LOCAL_DRIVERS });
      API.get("drivers/local", {
        params: {
          cityId: cityId ? cityId : undefined,
        },
      })
        .then((response) => {
          const data = response.data.data.filter(d => d.id !== currentDriverId);
          dispatch({
            type: FETCH_LOCAL_DRIVERS_SUCCESS,
            payload: data,
          });
        })
        .catch((error) => {
          dispatch({ type: FETCH_LOCAL_DRIVERS_FAILURE, payload: error });
        });
    } else { // For Interstate
      getDriverForReassignHandoff({
        driverId: currentDriverId,
        isStartJob: status === jobStatus.CHANGE_DRIVER
      });
    }
	};

  const getDriverForReassignHandoff = (payload) => {
    dispatch({ type: FETCH_INTERSTATE_DRIVERS });
    API.get("drivers/interstate", {
      params: payload
    })
      .then((response) => {
        dispatch({
          type: FETCH_INTERSTATE_DRIVERS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_INTERSTATE_DRIVERS_FAILURE, payload: error });
      });
  }

  const getInterstateJobsReassignHandoff = (payload) => {
    dispatch({ type: FETCH_INTERSTATE_JOBS_REASSIGN });
    API.get("interstateJobs/reassignJobs", { params: payload })
      .then((response) => {
        dispatch({
          type: FETCH_INTERSTATE_JOBS_REASSIGN_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_INTERSTATE_JOBS_REASSIGN_FAILURE, payload: error });
      });
  }

  const reassignInterstateJob = (payload = {}) => {
    dispatch({ type: RE_ASSIGN_DRIVER });
    API.put(`interstateJobs/${jobId}/reassignInterstateJob`, payload)
      .then((response) => {
        dispatch({
          type: RE_ASSIGN_DRIVER_SUCCESS,
          payload: response.data.data,
        });
        handleAssignDriverPopupClose();
        toast.success("Driver Re-Assigned Successfully");
        props.getInterstateJobs();
      })
      .catch((error) => {
        dispatch({ type: RE_ASSIGN_DRIVER_FAILURE, payload: error });
        setError(error.response.data.message);
      });
  }

  const reassignPendingInterstateJob = (payload = {}) => {
    dispatch({ type: RE_ASSIGN_DRIVER });
    API.put(`interstateJobs/${jobId}/reassignPendingInterstateJob`, payload)
      .then((response) => {
        dispatch({
          type: RE_ASSIGN_DRIVER_SUCCESS,
          payload: response.data.data,
        });
        handleAssignDriverPopupClose();
        toast.success("Driver Re-Assigned Successfully");
        props.getInterstateJobs();
      })
      .catch((error) => {
        dispatch({ type: RE_ASSIGN_DRIVER_FAILURE, payload: error });
        setError(error.response.data.message);
      });
  }

  const reassignLocalJobToDriver = (driverId, jobId) => {
    dispatch({ type: RE_ASSIGN_DRIVER });
    API.put(`jobs/${jobId}/reassignJob`, { driverId })
      .then((response) => {
        dispatch({
          type: RE_ASSIGN_DRIVER_SUCCESS,
          payload: response.data.data,
        });
        handleAssignDriverPopupClose();
        toast.success("Driver Re-Assigned Successfully");
        props.getJobs();
      })
      .catch((error) => {
        dispatch({ type: RE_ASSIGN_DRIVER_FAILURE, payload: error });
        setError(error.response.data.message);
      });
  }

  const reassignConsolidatedJobToDriver = (driverId, primeJobId) => {
    dispatch({ type: RE_ASSIGN_CONSOLIDATED_JOB });
    API.put(`jobs/${primeJobId}/reassignConsolidatedJob`, { driverId })
      .then((response) => {
        dispatch({
          type: RE_ASSIGN_CONSOLIDATED_JOB_SUCCESS,
          payload: response.data.data,
        });
        handleAssignDriverPopupClose();
        toast.success(`Jobs ${response.data.data.join(", ")} in the prime job P‑${primeJobId} have been reassigned successfully`);
        props.getJobs();
      })
      .catch((error) => {
        dispatch({ type: RE_ASSIGN_CONSOLIDATED_JOB_FAILURE, payload: error });
        toast.error(`One or more jobs in prime group P‑${primeJobId} cannot be reassigned. Please check job statuses and try again.`);
        setError(error.response.data.message);
      });
  }

  // API calling to check related prime job before assign driver
  const checkRelatedPrimeJob = (jobId) => {
    dispatch({ type: CHECK_RELATED_PRIME_JOB });
    return API.get(`jobs/${jobId}/checkRelatedPrimeJob`)
      .then((response) => {
        dispatch({
          type: CHECK_RELATED_PRIME_JOB_SUCCESS,
        });
        return response.data.data.id;
      })
      .catch((error) => {
        dispatch({
          type: CHECK_RELATED_PRIME_JOB_FAILURE,
        });
        return null;
      });
  }

	useEffect(() => {
		if (openDriverPopup) {
			getDriver();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cityId, openDriverPopup]);

  useEffect(() => {
    if (openReassignDriverHandoffPopup) {
      getDriverForReassignHandoff({ driverId: currentDriverId });
      getInterstateJobsReassignHandoff({ driverId: currentDriverId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openReassignDriverHandoffPopup]);

	// API calling to assign and reassign driver depending on status
  const assignDriverFormik = useFormik({
    initialValues: schema.assignDriverSchema,
    validationSchema: !props.isInterstate ? validationSchema.assignDriverValidationSchema : undefined,
    onSubmit: async (value) => {
      if (type === "Assign") {
        dispatch({ type: ASSIGN_DRIVER });
        API.put(`jobs/${jobId}/assignDriver`, { driverId: value.assignDriver })
          .then((response) => {
            dispatch({
              type: ASSIGN_DRIVER_SUCCESS,
              payload: response.data.data,
            });
            handleAssignDriverPopupClose();
            toast.success("Driver Assigned Successfully");
            props.getJobs();
          })
          .catch((error) => {
            dispatch({ type: ASSIGN_DRIVER_FAILURE, payload: error });
            setError(error.response.data.message);
          });
      } else {
        if (!props.isInterstate) { // For Local
          if (["Rejected", "Assigned"].includes(status)) {
            const relatedPrimeJobId = await checkRelatedPrimeJob(jobId);
            if (relatedPrimeJobId) {
              reassignConsolidatedJobToDriver(value.assignDriver, relatedPrimeJobId);
            } else {
              reassignLocalJobToDriver(value.assignDriver, jobId);
            }
          } else {
            if (
              ["In Transit", "Lodgement", "Loading", "Unloading"].includes(status)
            ) {
              dispatch({ type: CHANGE_DRIVER });
              API.put(`jobs/${jobId}/modifyDriver`, {
                newDriverId: value.assignDriver,
              })
                .then((response) => {
                  dispatch({
                    type: CHANGE_DRIVER_SUCCESS,
                    payload: response.data.data,
                  });
                  handleAssignDriverPopupClose();
                  toast.success("Driver Re-Assigned Successfully");
                  props.getJobs();
                })
                .catch((error) => {
                  dispatch({
                    type: CHANGE_DRIVER_FAILURE,
                    payload: error,
                  });
                  setError(error.response.data.message);
                });
            } else {
              dispatch({ type: RE_ASSIGN_CHANGE_DRIVER });
              API.put(`jobs/${jobId}/changeDriver`, {
                driverId: value.assignDriver,
                truckId: truckId,
              })
                .then((response) => {
                  dispatch({
                    type: RE_ASSIGN_CHANGE_DRIVER_SUCCESS,
                    payload: response.data.data,
                  });
                  handleAssignDriverPopupClose();
                  toast.success("Driver Re-Assigned Successfully");
                  props.getJobs();
                })
                .catch((error) => {
                  dispatch({
                    type: RE_ASSIGN_CHANGE_DRIVER_FAILURE,
                    payload: error,
                  });
                  setError(error.response.data.message);
                });
            }
          }
        } else { // For Interstate
          if (value.assignDriver) {
            if (status === jobStatus.CHANGE_DRIVER) {
              reassignPendingInterstateJob({ driverId: currentDriverId, newDriverId: value.assignDriver });
            } else {
              reassignInterstateJob({ driverId: value.assignDriver });
            }
          } else {
            setOpenConfirmPopup(true);
          }
        }
      }
    },
  });

  // API calling to reassign driver of handoff job
  const reassignDriverHandoffFormik = useFormik({
    initialValues: schema.reassignDriverHandoffInprogressSchema,
    validationSchema: validationSchema.reassignDriverHandoffInprogressValidationSchema,
    onSubmit: (value) => {
      const listJobs = value.handoffType === handoffType.all
        && value.listJobs.length === 0
        ? state.job?.interstateJobsReassignData.map(job => {
          return {
            jobId: job.id,
            jobRunsheetsId: job?.jobRunsheets[0]?.id
          }
        }) : value.listJobs;
      const checkHandoffType = value.listJobs.length === state.job?.interstateJobsReassignData?.length ? handoffType.all : value.handoffType;
      const checkSwapType = value.handoffType === handoffType.individual
        ? swapType.jobOnly
        : value.swapType || swapType.jobOnly;

      if (listJobs.length === 0 && value.handoffType === handoffType.all) {
        toast.error("Stale data: Job already handed off. Please refresh your list.");
        return;
      }

      const payload = {
        driverId: currentDriverId,
        swapType: checkSwapType,
        listJobs,
        handoffType: checkHandoffType,
        ...(value.assignDriver ? { newDriverId: value.assignDriver } : {})
      }
      dispatch({ type: CREATE_HANDOFF });
      API.post(`interstateJobs/handoffJob`, payload)
        .then((response) => {
          dispatch({
            type: CREATE_HANDOFF_SUCCESS,
            payload: response.data.data,
          });
          toast.success(response.data.message);
          handleReassignDriverHandoffPopupClose();
          props.getInterstateJobs();
        })
        .catch((error) => {
          dispatch({ type: CREATE_HANDOFF_FAILURE, payload: error });
          toast.error(error?.response?.data?.message);
        });
    },
  });

	const handleDriverPoppupOpen = (type, id, status, truck, city, driverId, jobRunsheet) => {
		setJobId(id);
		setOpenDriverPopup(true);
		setType(type);
		setStatus(status);
		setTruckId(truck);
		setCityId(city);
    setCurrentDriverId(driverId);
	};

	const handleAssignDriverPopupClose = () => {
		setOpenDriverPopup(false);
		assignDriverFormik.handleReset();
		setError("");
    setJobId("");
		setType("");
		setStatus("");
		setTruckId("");
		setCityId("");
    setCurrentDriverId("");
	};
	const handleReassignDriverHandoffPopupClose = () => {
		setOpenReassignDriverHandoffPopup(false);
		reassignDriverHandoffFormik.handleReset();
		setError("");
    setSort({
      orderBy: "",
      order: ""
    });
    setCurrentDriverId("");
    setCurrentJob(null);
	};

  const handleReassignInterstateJobPopupOpen = (row) => {
    if (row.jobRunsheets.length > 0 && row.jobStatuses?.name !== jobStatus.CHANGE_DRIVER) {
      handleReassignDriverHandoffPopupOpen();
      setCurrentDriverId(row.drivers?.id);
      setCurrentJob(row);
    } else {
      handleDriverPoppupOpen(
        "interstate",
        row.id,
        row.jobStatuses?.name,
        row.trucks?.id,
        row.cities?.id,
        row.drivers?.id,
        row.jobRunsheets
      );
    }
  };

  const isCompleted = state.job.jobsData?.rows?.map((item) => {
    return item.jobStatuses && item.jobStatuses.name;
  });

  const handleConfirmPopup = () => {
    if (openDriverPopup) {
      if (status === jobStatus.CHANGE_DRIVER) {
        reassignPendingInterstateJob({ driverId: currentDriverId });
      } else {
        reassignInterstateJob();
      }
    }
    setOpenConfirmPopup(false);
  }

  const handleReassignDriverHandoffPopupOpen = () => {
    setOpenReassignDriverHandoffPopup(true);
  };

  const handleSorting = (event, item) => {
    let isAsc = sort.orderBy === item.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: item.sortTitle
      }
    ));
    let payload = {
      orderBy: item.sortTitle,
      order: isAsc ? "desc" : "asc",
    };
    payload = {
      ...payload,
      driverId: currentDriverId
    };
    getInterstateJobsReassignHandoff(payload);
  };

	return (
		<>
			<div className={classes.TableWrapper}>
				<Loader loading={state.job?.loadingJobs || state.job?.reviewingJobs || state.job?.reviewingJobs || state.job?.loadingInterstateJobs || state.job?.sendingToInterstateJobPool} />
				<TableContainer component={Paper} className={classes.customTable}>
					<Table stickyHeader aria-label="simple table">
						<TableHead>
							<TableRow>
								{isPermission &&
								isCompleted &&
								isCompleted.includes("Completed") ? (
									<TableCell className="check">
										<FormControlLabel
											className="custom-checkbox"
											control={
												<Checkbox
													icon={<img src={uncheckedIcon} alt="CheckBox" />}
													checkedIcon={
														<img src={checkedIconOrange} alt="CheckBox" />
													}
													onChange={(e) => props.handleMainChange(e)}
													checked={props._maincheck}
													name="check"
												/>
											}
										/>
									</TableCell>
								) : (
									<TableCell className="check"></TableCell>
								)}
								{(props.isInterstate ? dashboardInterstateListingHeader : dashboardListingHeader).map((item, index) => {
									return (
										<TableCell key={index} className={item.className}>
											{item.title}
											{item.sort && (
												<TableSortLabel
													direction={
														props.orderBy === item.sortTitle
															? props.order
															: "desc"
													}
													active={true}
													onClick={(e) => props.handleSorting(e, item)}
												></TableSortLabel>
											)}
										</TableCell>
									);
								})}
							</TableRow>
						</TableHead>
						<TableBody>
							{(!props.isInterstate ? (state.job?.jobsData) : (state.job?.interstateJobsData))?.count === 0 ? (
								<TableRow className="no-data">
									<TableCell colSpan={!props.isInterstate ? 13 : 13}>
										<span>No Data Found</span>
									</TableCell>
								</TableRow>
							) : (
              (!props.isInterstate ? (state.job?.jobsData?.rows) : (state.job?.interstateJobsData?.rows))?.map((row, index) => {
                  return (
                      <TableRow key={index}>
                          {isPermission &&
                          row.jobStatuses &&
                          row.jobStatuses.name === "Completed" &&
                          row?.sourceId !== sourceId.CARGO_WISE ? (
                              <TableCell className="check">
                                  <FormControlLabel
                                      className="custom-checkbox"
                                      control={
                                          <Checkbox
                                              icon={
                                                  <img src={uncheckedIcon} alt="CheckBox" />
                                              }
                                              checkedIcon={
                                                  <img src={checkedIconOrange} alt="CheckBox" />
                                              }
                                              onChange={(e) => props.handleChange(row, e)}
                                              checked={
                                                !props.isInterstate ? state.job.jobsData?.rows[index]["_rowChecked"] === true : state.job.interstateJobsData?.rows[index]["_rowChecked"] === true
                                              }
                                              name="check"
                                          />
                                      }
                                  />
                              </TableCell>
                          ) : (
                              <TableCell></TableCell>
                          )}
                          <TableCell className="jobId">
                              <Link
                                  to={{
                                      pathname: props.isInterstate ? `${routes.interstateJobDetail}/${row.id}` : `${routes.jobDetail}/${row.id}`,
                                      state: row,
                                  }}
                                  target="_blank"
                              >
                                  {row.id ? row.id : "-"} {row?.sourceId === sourceId.CARGO_WISE ? "*" : ""}
                              </Link>
                          </TableCell>
                          {/* Added city column https://wymap.atlassian.net/browse/MAPTRAK-856 */}
                          <TableCell>{row?.cities?.name || "-"}</TableCell>
                          <TableCell
                              className={`driver ${jobListingRequestStyle(
                                  row.jobStatuses &&
                                      row.jobStatuses?.name === "Not Assigned"
                                      ? "Assign Driver"
                                      : row.jobStatuses?.name === "Rejected" ||
                                        "Change Driver"
                                      ? "Re-Assign"
                                      : ""
                              )}`}
                          >
                              {row.drivers?.name ? (
                                  row.jobStatuses?.name === "Rejected" ? (
                                      <Button
                                          color="primary"
                                          className="primary-btn"
                                          onClick={() =>
                                              handleDriverPoppupOpen(
                                                  "ReAssign",
                                                  row.id,
                                                  row.jobStatuses?.name,
                                                  row.trucks?.id,
                                                  row.cities.id,
						                                      row.drivers?.id,
                                                  row.jobRunsheets
                                              )
                                          }
                                      >
                                          Re-Assign driver
                                      </Button>
                                  ) : row.jobStatuses?.name === jobStatus.CHANGE_DRIVER ? (
                              <span
                                className="re-assign-link"
                                onClick={() =>
                                  props.isInterstate
                                    ? handleReassignInterstateJobPopupOpen(row)
                                    : handleDriverPoppupOpen(
                                      "ReAssign",
                                      row.id,
                                      row.jobStatuses?.name,
                                      row.trucks?.id,
                                      row.cities.id,
                                      row.drivers?.id,
                                      row.jobRunsheets
                                    )
                                }
                              >
                                {row.drivers?.name}
                              </span>
                                  ) : [
                                          "Assigned",
                                          "In Transit",
                                          "Lodgement",
                                          "Loading",
                                          "Unloading",
                                    ].includes(row.jobStatuses?.name) ? (
                                  <span
                                    className="re-assign-link"
                                    onClick={() =>
                                      props.isInterstate
                                        ? handleReassignInterstateJobPopupOpen(row)
                                        : handleDriverPoppupOpen(
                                          "ReAssign",
                                          row.id,
                                          row.jobStatuses?.name,
                                          row.trucks?.id,
                                          row.cities.id,
                                          row.drivers?.id,
                                          row.jobRunsheets
                                        )
                                    }
                                  >
                                    {row.drivers?.name}
                                  </span>
                                  ) : (
                                      row.drivers?.name
                                  )
                              ) : row.jobStatuses?.name === "Not Assigned" ? (
                                  <Button
                                      color="primary"
                                      className="primary-btn"
                                      onClick={() =>
                                        handleDriverPoppupOpen(
                                            "Assign",
                                            row.id,
                                            "",
                                            "",
                                            row.cities.id,
                                            row.drivers?.id,
                                            row.jobRunsheets
                                          )
                                      }
                                  >
                                      Assign driver
                                  </Button>
                              ) : (
                                  <Button
                                      color="primary"
                                      className="primary-btn"
                                      onClick={() =>
                                          handleDriverPoppupOpen(
                                              "ReAssign",
                                              row.id,
                                              row.jobStatuses?.name,
                                              row.trucks?.id,
                                              row.cities.id,
					                                    row.drivers?.id,
                                              row.jobRunsheets
                                          )
                                      }
                                  >
                                      Re-Assign driver
                                  </Button>
                              )}
                          </TableCell>
                          <TableCell className="truck-rego break-word">
                            {row.trucks ? row.trucks.rego : "-"}
                          </TableCell>
                          {props.isInterstate && (
                            <TableCell className="trailer break-word">
                              {row?.trailers ? row?.trailers?.rego : "-"}
                            </TableCell>)
                          }
                          <TableCell
                              className={`status ${dashboardRequestStatusColors(
                                  row.jobStatuses ? row.jobStatuses.name : ""
                              )}`}
                          >
                              <span>
                                  {row.jobStatuses ? row.jobStatuses.name : "-"}
                              </span>
                          </TableCell>
                          <TableCell className="customerName break-word">
                              {row.customers ? row.customers.name : "-"}
                          </TableCell>
                          {!props.isInterstate && (
                            <TableCell className="cto">
                              {row.ctos ? row.ctos.name : "-"}
                            </TableCell>)
                          }
                          {!props.isInterstate && (
                            <TableCell className="jobType">
                              {row.jobTypes ? row.jobTypes.name : "-"}
                            </TableCell>)
                          }
                          {!props.isInterstate && (
                            <TableCell className="cargoType">
                              {row.cargoTypes ? row.cargoTypes.name : "-"}
                            </TableCell>)
                          }
                          {props.isInterstate && (
                            <TableCell className="pickUpLocation">
                              {row?.pickUpLocation ? row?.pickUpLocation : "-"}
                            </TableCell>)
                          }
                          {props.isInterstate && (
                            <TableCell className="dropOffLocation">
                              {row?.dropOffLocation ? row?.dropOffLocation : "-"}
                            </TableCell>)
                          }
                          <TableCell className="date">
                              {row?.createdAt
                                  ? utcToTimezone(
                                      row?.createdAt,
                                      row?.cities?.timezone,
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                          </TableCell>
                          <TableCell className="net-charge">
                            {row?.net
                              ? `$${formatNetCharge(row?.net)}`
                              : "-"}
                          </TableCell>
                          <TableCell className="completion-date">
                              {row?.completedAt
                                  ? utcToTimezone(
                                      row?.completedAt,
                                      row?.cities?.timezone,
                                      "DD/MM/YYYY"
                                    )
                                  : "-"}
                          </TableCell>
                      </TableRow>
                  );})
              )}

						</TableBody>
					</Table>
					<AssignDriverPopup
						handleClose={handleAssignDriverPopupClose}
						open={openDriverPopup}
						formik={assignDriverFormik}
						error={error}
						type={type}
            isInterstate={props.isInterstate}
            currentDriverId={currentDriverId}
					/>
          <ReassignDriverHandoffPopup
						handleClose={handleReassignDriverHandoffPopupClose}
						open={openReassignDriverHandoffPopup}
						formik={reassignDriverHandoffFormik}
						error={error}
            handleSorting={handleSorting}
            job={currentJob}
            order={sort.order}
            orderBy={sort.orderBy}
					/>
          <CustomConfirmationPopup
            open={openConfirmPopup}
            handleClose={() => setOpenConfirmPopup(false)}
            handleConfirm={handleConfirmPopup}
            title={"Confirmation"}
            message={<span
              dangerouslySetInnerHTML={{
                __html: "New interstate driver is not specified. The job will be sent to the Job Pool instead.<br /><br />Do you want to proceed?"
              }}
            />}
            closeMessageBtn={"Cancel"}
            confirmMessageBtn={"Proceed"}
            error={error}
          />
        </TableContainer>
				{(!props.isInterstate ? state.job?.jobsData : state.job?.interstateJobsData)?.count !== 0 && (
					<div className="pagination-wrapper">
						<Pagination
							count={!props.isInterstate ? state.job?.jobsData?.count : state.job?.interstateJobsData?.count}
							page={props.page}
							handleChangePage={props.handleChangePage}
							rowsPerPage={props.rowsPerPage}
							handleChangeRowsPerPage={props.handleChangeRowsPerPage}
						/>
					</div>
				)}
			</div>
		</>
	);
}
export default TableListing;
